<template>
    <div class="px-8">
        <form-header title="System">
        </form-header>

        <div class="mt-1 max-w-xs text-sm text-gray-500">This panel hosts system settings, please do not change or click anything here.</div>

        <form-div class="pt-0" label="Expiry Reminder Job">
            <custom-button class="w-56 -mt-2"  
                        @click="doExpiryReminderJob">
                        Run Expiry Job Now<img v-if="expiryReminderJobRunning" class="mx-2" src="@/assets/loading-spinner.svg">
            </custom-button>
        </form-div>

        <!-- <form-div class="pt-0" label="Update Photos Job">
            <custom-button class="w-56 -mt-2"  
                        @click="doUpdatePhotosJob">
                        Run Update Photos Job Now<img v-if="updatePhotosJobRunning" class="mx-2" src="@/assets/loading-spinner.svg">
            </custom-button>
        </form-div> -->

        <form-div class="pt-0" label="Think Sync Job">
            <custom-button class="w-56 -mt-2"  
                        @click="doThinkSyncJob">
                        Run Think Job Now<img v-if="thinkSyncRunning" class="mx-2" src="@/assets/loading-spinner.svg">
            </custom-button>
        </form-div>

        <form-file-input class="pt-2" id="docname" type="file" label="Upload Think Data" accept=".csv" :error="msg.newFile" v-model="newFile"/>
        <form-div v-if="newFile">
            <custom-button type="primary" class="-mt-2 w-24 mr-2" @click="onUpload">Upload</custom-button>
        </form-div>
        <form-div v-if="uploadMessage">{{uploadMessage}}</form-div>

        <form-input class="pt-2" id="email" type="email" label="Send a test email" v-model="email" :error="msg.email"/>
        <form-div class="pt-2" label="">
            <custom-button class="w-56 -mt-2"  
                        @click="doSendTestEmail">
                        Send<img v-if="sendingTestEmail" class="mx-2" src="@/assets/loading-spinner.svg">
            </custom-button>
        </form-div>


    </div>
</template>

<script>
import FormHeader from '../components/FormHeader.vue'
import FormDiv from '../components/FormDiv.vue'
import CustomButton from '../components/CustomButton.vue'
import FormFileInput from '../components/FormFileInput.vue'
import FormInput from '../components/FormInput.vue'

export default {
    components: { FormHeader, CustomButton, FormDiv, FormFileInput, FormInput },
    data: function() {
        return {
            thinkSyncRunning: false,
            expiryReminderJobRunning: false,
            updatePhotosJobRunning: false,
            sendingTestEmail: false,
            newFile: null,
            uploadMessage: '',
            msg: {},
            email: ''
        }
    },
    props: [
        'id',
        'prev'
    ],
    methods: {
        doThinkSyncJob: async function() {
            if (this.thinkSyncRunning) { return }
            this.thinkSyncRunning = true
            await this.axios.post('/system/runThinkSyncJob')
            this.thinkSyncRunning = false
        },
        doExpiryReminderJob: async function() {
            if (this.expiryReminderJobRunning) { return }
            this.expiryReminderJobRunning = true
            await this.axios.post('/system/runExpiryReminderJob')
            this.expiryReminderJobRunning = false
        },
        doUpdatePhotosJob: async function() {
            if (this.updatePhotosJobRunning) { return }
            this.updatePhotosJobRunning = true
            await this.axios.post('/system/updatePhotosJob')
            this.updatePhotosJobRunning = false
        }, 
        doSendTestEmail: async function() {

            this.msg.email = ''
            if (this.sendingTestEmail) return
            if (!this.$validEmail(this.email)) { this.msg.email = 'Enter a valid email'; return }

            this.sendingTestEmail = true
            await this.axios.post('/system/sendTestEmail', { email: this.email })
            this.sendingTestEmail = false
        },
        onUpload: async function() {
            let data = new FormData();
            data.append('data', this.newFile, this.newFile.name);
            let ret = await this.axios.post('/system/thinkUpload', data, {
                headers: {
                    'Content-Type': `multipart/form-data`,
                }
            })
            if (ret.data) {
                if (ret.data.status == 'success') {
                    this.msg = {}
                    this.newFile = null
                    this.uploadMessage = ret.data.description
                }
                else {
                    this.msg.newFile = ret.data.description
                }
            }
            else {
                this.msg.newFile = 'Failed to upload'
            }
        }
    }
}
</script>